// Pure helpers for the KPI tile deltas on AdminUploadsStatsSection. Extracted
// so the color-mapping logic — which is easy to get wrong the moment we add a
// new "bad-when-up" metric — can be tested without spinning up MUI + Recharts
// + a whole render tree.
//
// polarity semantics:
//   "positive" — more is better (Successful uploads). Up = green, down = red.
//   "negative" — more is worse (Cancelled·technical, Cancelled·non-technical,
//                Failed). Up = red, down = green.

export const DELTA_COLORS = Object.freeze({
    GOOD: "#4ade80",     // green — desirable direction
    BAD: "#f87171",      // red — undesirable direction
    NEUTRAL: "#94a3b8",  // grey — no change / no prior period
});

/**
 * Classify the current-vs-previous count into an up/down/flat delta with a
 * percentage. `null` pct means "no prior period to compare against" — caller
 * renders "new" instead of "+X%".
 */
export const computeDelta = (current, previous) => {
    if (!previous && !current) return { kind: "flat", pct: 0 };
    if (!previous) return { kind: "up", pct: null };

    const diff = current - previous;
    if (diff === 0) return { kind: "flat", pct: 0 };

    const pct = (diff / previous) * 100;
    return { kind: diff > 0 ? "up" : "down", pct };
};

/**
 * Pick the foreground colour for a delta, honouring polarity. Kept dumb on
 * purpose: no defaulting on invalid polarity beyond "!= 'negative' means
 * positive", because a typo would otherwise silently paint everything green.
 */
export const pickDeltaColor = (kind, polarity = "positive") => {
    if (kind === "flat") return DELTA_COLORS.NEUTRAL;
    const upIsGood = polarity !== "negative";
    if (kind === "up") return upIsGood ? DELTA_COLORS.GOOD : DELTA_COLORS.BAD;
    if (kind === "down") return upIsGood ? DELTA_COLORS.BAD : DELTA_COLORS.GOOD;
    return DELTA_COLORS.NEUTRAL;
};
